import { render, staticRenderFns } from "./CrftList.vue?vue&type=template&id=59e04d04&scoped=true&"
import script from "./CrftList.vue?vue&type=script&lang=js&"
export * from "./CrftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e04d04",
  null
  
)

export default component.exports